module.exports = __webpack_public_path__ + "media/images/flags/32/Malta-96ac5203af4d78e8d147d629e4fca55c.png";